<div mat-dialog-header class="title">
    Download Image
</div>

<div mat-dialog-content>
    <p>Which version of the image would you like to download?</p>
    <mat-radio-group [(ngModel)]="imageType">
        <mat-radio-button value="base">Without Contours</mat-radio-button>
        <mat-radio-button value="merged">With Contours</mat-radio-button>
    </mat-radio-group>
</div>

<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="null">Cancel</button>
    <button mat-button color="primary" [mat-dialog-close]="imageType" cdkFocusInitial>Download</button>
</div>